import { HeadWrapper, Wrapper, Head, ButtonWrapper } from './product-purchase-page.styles';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Typography } from '@shared/ui/typography/typography';
import { ProductCreateOwnOrder } from '@widgets/create-own-order/ui/product-create-own-order';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { UserRoles } from '@shared/model/user';
import { ProductBuyManagerOrder } from '@widgets/buy-manager-order/ui/product-buy-manager-order';

export const ProductPurchasePage = () => {
    const user = useCurrentUserSelector();
    const route = useRouteMatch<{ id: string }>();
    const routeId = Number(route.params.id);
    const history = useHistory();

    const userRole = user?.role.code;

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <ButtonWrapper>
                            <Button
                                round
                                size='xl'
                                buttonType='secondary'
                                startAdornment={<ArrowsChevronLeft />}
                                onClick={() => history.goBack()}
                            />
                        </ButtonWrapper>
                    )}
                    <Typography size='h6'>Приобретение продукта</Typography>
                </Head>
            </HeadWrapper>
            {userRole === UserRoles.Employee && <ProductCreateOwnOrder productId={routeId} />}
            {userRole === UserRoles.Manager && <ProductBuyManagerOrder orderId={routeId} />}
        </Wrapper>
    );
};
